import { Col, Row, Button } from "react-bootstrap";
import { TODIS_FORM_FIELD, TODIS_FORM_DSC, TODIS_FORM_FIELD_OTHER } from "../../../../components/Forms";
import React, { useState, useEffect } from 'react';
import { BsExclamationCircleFill } from 'react-icons/bs';
import { loadModules } from 'esri-loader';

const TODIS_FORM_OTHER_RWP = (props) => {
    console.log(props.values)
    const [formValues, setFormValues] = useState({});
    const [attributes, setAttributes] = useState({});

    useEffect(() => {
        getRegionalPartnerGeo();
    }, [props.values.liveRwProjId]);    //CAMBIAR

    const getRegionalPartnerGeo = async () => {
        console.log("getRegionalPartnerGeo is called");
        try {
            const [Query, query] = await loadModules(["esri/rest/support/Query", "esri/rest/query"]);
            console.log("Modules loaded", Query, query);

            let queryUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/25";
            console.log("Query URL:", queryUrl);

            let queryObject = new Query();
            queryObject.where = `live_rw_proj_id=${props.values.liveRwProjId}`;
            queryObject.returnGeometry = false;
            queryObject.outFields = "*";

            console.log("Executing query");
            const results = await query.executeQueryJSON(queryUrl, queryObject);
            console.log("Query executed", results);

            if (results.features.length > 0) {
                const attributes = results.features[0].attributes;
                setAttributes(attributes);
                setFormValues(attributes);
            } else {
                console.log("No features found with the given live_rw_proj_id");
            }
        } catch (error) {
            console.log("Something went wrong", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const key = name.split('.').pop();

        // Detecta el tipo original del valor
        const originalValue = formValues[key];
        let newValue = value;

        // Convertir a número si el valor original es un número
        if (!isNaN(originalValue) && originalValue !== null && originalValue !== "") {
            newValue = Number(value);
        }

        setFormValues({
            ...formValues,
            [key]: newValue,
        });
    };

    const saveJsonAndUpdate = async () => {
        console.log("Form values to save:", formValues);

        try {
            await deleteRegionalPartnerGeo(props.values.liveRwProjId);
            await handlePost(formValues);
            setTimeout(() => {
                getRegionalPartnerGeo();
            }, 1000);
        } catch (error) {
            console.log("Error in saveJsonAndUpdate:", error);
        }
    };

    const deleteRegionalPartnerGeo = async (liveRwProjId) => {
        console.log("deleteRegionalPartnerGeo is called");
        try {
            const [deleteFeatures] = await loadModules(["esri/rest/query"]);
            console.log("Modules loaded", deleteFeatures);

            let deleteUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/25/deleteFeatures";
            console.log("Delete URL:", deleteUrl);

            let formData = new FormData();
            formData.append("where", `live_rw_proj_id=${liveRwProjId}`); //CAMBIAR
            formData.append("f", "json");

            console.log("Executing delete");

            const response = await fetch(deleteUrl, {
                method: 'POST',
                body: formData
            });

            const deleteResult = await response.json();
            console.log("Delete executed", deleteResult);

        } catch (error) {
            console.log("Something went wrong", error);
        }
    };

    const handlePost = async (dataToSave) => {
        const postUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/25/applyEdits";
        const excludedFields = ["objectid", "globalid"];
        const filteredData = Object.keys(dataToSave)
            .filter(key => !excludedFields.includes(key))
            .reduce((obj, key) => {
                obj[key] = dataToSave[key];
                return obj;
            }, {});

        const postPayload = {
            adds: [
                {
                    aggregateGeometries: null,
                    geometry: null,
                    symbol: null,
                    attributes: {
                        ...filteredData,
                    },
                    popupTemplate: null
                }
            ]
        };

        try {
            const response = await fetch(postUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    f: 'json',
                    adds: JSON.stringify(postPayload.adds)
                }).toString(),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            console.log("Post response", result);
        } catch (error) {
            console.error("Failed to post", error);
        }
    };


    const handleUpdate = () => {
        saveJsonAndUpdate();
    };

    const generateFormFields = (formValues, typeForm, errors, touched, disabled) => {
        const excludedFields = ["objectid", "globalid", "live_rw_proj_id"];

        return Object.keys(formValues)
            .filter(key => !excludedFields.includes(key))
            .map(key => (
                <Col lg={6} key={key}>
                    <TODIS_FORM_FIELD
                        id={`${typeForm}.${key}`}
                        label={key.charAt(0).toUpperCase() + key.slice(1)}
                        name={`${typeForm}.${key}`}
                        disabled={disabled}
                        holder={formValues[key]}
                        onChange={handleChange}
                    />
                    {errors[typeForm] && errors[typeForm][key] && touched[typeForm] && touched[typeForm][key] ? (
                        <div className="todis-field-validation-err">
                            <span className="todis-field-validation-err-icon">
                                <BsExclamationCircleFill size={20} />
                            </span>
                            Error: {errors[typeForm][key]}
                        </div>
                    ) : null}
                </Col>
            ));
    };

    return (
        <Row>
            {generateFormFields(attributes, props.TypeForm, props.errors, props.touched, props.disabled)}
            <Col lg={12}>
                <TODIS_FORM_DSC id={`${props.TypeForm}${".remarks"}`} label="Remarks" name={`${props.TypeForm}${".remarks"}`} disabled={props.disabled} />
                {props.errors[props.TypeForm] && props.errors[props.TypeForm].remarks && props.touched[props.TypeForm] && props.touched[props.TypeForm].remarks ? (
                    <div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {props.errors[props.TypeForm].remarks}</div>) : null}
            </Col>
            {!window.location.href.includes("/DataSharing") && (

                <Col lg={12}>
                    <Button onClick={handleUpdate}>Recalculate</Button>
                </Col>
            )}
        </Row>
    );
};

export default TODIS_FORM_OTHER_RWP;
